import { TRACK, IDENTIFY, PAGE, LINKCLICK } from '../constants'
import AppcuesApi from '~/lib/apis/AppcuesApi'
import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'

export default function (
    appcuesApi: AppcuesApi,
): Omit<AnalyticsHandlers, typeof LINKCLICK> {
    let started = false

    return {
        [TRACK]({ event, properties }) {
            if (started) {
                appcuesApi.track(event, properties)
            }
        },
        [PAGE]() {
            // Appcues calls "page" automatically when
            // `identify` or `anonymous` is called
            if (started) {
                appcuesApi.page()
            }
        },
        [IDENTIFY](payload) {
            if (payload.isImpersonating) {
                // don't turn on Appcues if the logged in user is impersonating
                return
            }

            if (payload.userId) {
                appcuesApi.identify(payload.userId, payload.traits)
            } else {
                appcuesApi.anonymous()
            }

            started = true
        },
    }
}
